<!--
 * @Author: LiuMeiYu
 * @Date: 2023-02-01 21:42:18
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-06-19 11:15:24
 * @FilePath: \nivara\src\views\set\components\setSecurityView.vue
 * @Description: *
 * *
 * Copyright (c) 2023 by yihua, All Rights Reserved.
-->
<template>
  <div class="set-security-container" v-loading="userInfoLoading">
    <div class="set-item">
      <div class="set-item-left">
        Login Password
        <div class="security-value">Set</div>
      </div>
      <el-button class="btn-edit" @click="loginPasswordRef.open()"
        >Edit</el-button
      >
    </div>
    <div class="set-item">
      <div class="set-item-left">
        Bind Email
        <div class="security-value">{{ userInfoData.email || "Unbound" }}</div>
      </div>
      <el-button class="btn-edit" @click="bindEmailRef.open()">Edit</el-button>
    </div>
    <div class="set-item">
      <div class="set-item-left">
        Bind Phone
        <div class="security-value">
          {{ userInfoData.whatsapp || "Unbound" }}
        </div>
      </div>
      <el-button class="btn-edit" @click="bindPhoneRef.open()">Edit</el-button>
    </div>
    <div class="set-item">
      <div class="set-item-left">
        Withdrawal password
        <div class="security-value">Set</div>
      </div>
      <el-button class="btn-edit" @click="withdrawPasswordRef.open()"
        >Edit</el-button
      >
    </div>
    <!-- 修改登录密码 -->
    <Popup title="Login Password" ref="loginPasswordRef">
      <template #content>
        <div class="login-password-content">
          <el-form :model="loginPasswordFormData" label-position="top">
            <el-form-item label="Current Password">
              <el-input
                v-model="loginPasswordFormData.currentPassword"
                type="password"
                show-password
                max="20"
                placeholder="Please Enter login password"
              />
            </el-form-item>
            <el-form-item label="New Password">
              <el-input
                v-model="loginPasswordFormData.newPassword"
                type="password"
                show-password
                max="20"
                placeholder="Please Enter new password"
              />
            </el-form-item>
          </el-form>
          <div class="login-password-tips">
            The password must contain at least 5 numbers.
          </div>
          <el-button @click="submitSetting('loginPassword')">Submit</el-button>
        </div>
      </template>
    </Popup>
    <!-- 绑定邮箱 -->
    <Popup title="Bind Email" ref="bindEmailRef">
      <template #content>
        <div class="bind-email-content">
          <div v-if="userInfoData.is_email_bind">
            <div>You have bound your email：</div>
            <div class="bind-email-email">
              {{ userInfoData.email }}
            </div>
          </div>
          <div v-else>
            <el-form :model="bindEmailFormData" label-position="top">
              <el-form-item label="Email">
                <el-input
                  v-model="bindEmailFormData.email"
                  placeholder="Please enter your email address"
                />
              </el-form-item>
              <el-form-item label="Verification code">
                <el-input
                  v-model="bindEmailFormData.code"
                  maxlength="4"
                  placeholder="Enter the code you received"
                >
                  <template #append>
                    <div class="bindemail-code-text" @click="sendBindEmailCode">
                      {{ bindEmailCodeText }}
                    </div>
                  </template>
                </el-input>
              </el-form-item>
            </el-form>
            <el-button @click="submitSetting('bindemail')">Submit</el-button>
          </div>
        </div>
      </template>
    </Popup>
    <!-- 绑定手机 -->
    <Popup title="Bind Phone" ref="bindPhoneRef">
      <template #content>
        <div class="bind-phone-content">
          <div v-if="userInfoData.whatsapp_bind">
            <div>You have bound your WhatsApp</div>
            <div class="bind-phone-phone">{{ userInfoData.whatsapp }}</div>
          </div>
          <div v-else>
            <el-form
              class="bind-phone-form"
              label-position="top"
              :model="bindPhoneFormData"
            >
              <el-form-item label="Phone">
                <el-input
                  v-model="bindPhoneFormData.phone"
                  placeholder="Enter your phone number"
                >
                  <template #prepend>
                    <el-select
                      v-model="bindPhoneCountryCode"
                      style="width: 150px"
                    >
                      <el-option
                        v-for="item in countryCodeListData"
                        :key="item.id"
                        :label="item.name_en + ' ' + item.code"
                        :value="item.code"
                      ></el-option>
                    </el-select>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item label="Verification code">
                <el-input
                  v-model="bindPhoneFormData.code"
                  maxlength="4"
                  placeholder="Enter the code you received"
                >
                  <template #append>
                    <div class="bindphone-code-text" @click="sendBindPhoneCode">
                      {{ bindPhoneCodeText }}
                    </div>
                  </template>
                </el-input>
              </el-form-item>
            </el-form>
            <el-button @click="submitSetting('bindphone')">Submit</el-button>
          </div>
        </div>
      </template>
    </Popup>
    <!-- 修改提现密码 -->
    <Popup title="Withdraw Password" ref="withdrawPasswordRef">
      <template #content>
        <div class="withdraw-password-content">
          <el-form :model="withdrawPasswordFormData" label-position="top">
            <el-form-item label="Enter withdrawal password">
              <el-input
                v-model="withdrawPasswordFormData.withdrawPassword"
                type="password"
                show-password
                maxlength="20"
                placeholder="Please Enter withdrawal password"
              />
            </el-form-item>
            <el-form-item label="Enter your withdrawal password again">
              <el-input
                v-model="withdrawPasswordFormData.withdrawPasswordAgain"
                type="password"
                show-password
                maxlength="20"
                placeholder="Please Enter withdrawal password again"
              />
            </el-form-item>
          </el-form>
          <div class="withdraw-password-tips">
            The password must contain at least 6 numbers.
          </div>
          <el-button @click="submitSetting('withdrawPassword')"
            >Submit</el-button
          >
        </div>
      </template>
    </Popup>
  </div>
</template>
<script>
import {
  defineComponent,
  nextTick,
  onMounted,
  reactive,
  ref,
  toRefs,
} from "@vue/runtime-core";
import Popup from "../../../components/popupView.vue";
import {
  getUserInfoApi,
  getCountryCodeApi,
  setWithdrawPasswordApi,
  updateLoginPasswordApi,
  sendBindEmailVerifyCodeApi,
  getWhatsAppVerificationCodeApi,
  userBindEmailApi,
  userBindPhoneApi,
} from "../../../api/index";
import { ElNotification } from "element-plus";

export default defineComponent({
  name: "MySecurity",
  components: { Popup },
  setup() {
    onMounted(() => {
      getUserInfo();
      getCountryCode();
    });
    const loginPasswordRef = ref(null);

    const bindEmailRef = ref(null);
    const isSendBindEmailCodeAgain = ref(true);
    let bindEmailCodeInterval = ref(null);
    const bindEmailCodeTime = ref(60);
    const bindEmailCodeText = ref("Send");

    const bindPhoneRef = ref(null);
    const bindPhoneCountryCode = ref("234");
    const isSendBindPhoneCodeAgain = ref(true);
    let bindPhoneCodeInterval = ref(null);
    const bindPhoneCodeTime = ref(60);
    const bindPhoneCodeText = ref("Send");

    const withdrawPasswordRef = ref(null);
    const state = reactive({
      userInfoData: {},
      loginPasswordFormData: {
        currentPassword: "",
        newPassword: "",
      },
      bindEmailFormData: {
        email: "",
        code: "",
      },
      countryCodeListData: [],
      bindPhoneFormData: {
        phone: "",
        code: "",
      },
      withdrawPasswordFormData: {
        withdrawPassword: "",
        withdrawPasswordAgain: "",
      },
    });
    const submitSetting = (settingType) => {
      switch (settingType) {
        case "loginPassword":
          setLoginPassword();
          break;
        case "bindemail":
          bindEmail();
          break;
        case "bindphone":
          bindPhone();
          break;
        case "withdrawPassword":
          setWithdrawPassword();
          break;
        default:
          break;
      }
    };
    // 修改登录密码
    const setLoginPassword = () => {
      if (state.loginPasswordFormData.currentPassword) {
        if (state.loginPasswordFormData.currentPassword.length >= 5) {
          if (state.loginPasswordFormData.newPassword) {
            if (state.loginPasswordFormData.newPassword >= 5) {
              updateLoginPasswordApi({
                password: state.loginPasswordFormData.currentPassword,
                new_password: state.loginPasswordFormData.newPassword,
              }).then((res) => {
                if (res.data.success) {
                  ElNotification({
                    title: "Tips",
                    message: "Setting Success",
                    type: "success",
                    duration: 2000,
                  });
                  loginPasswordRef.value.close();
                  nextTick(() => {
                    state.loginPasswordFormData.currentPassword = "";
                    state.loginPasswordFormData.newPassword = "";
                  });
                } else {
                  ElNotification({
                    title: "Tips",
                    message: res.data.msg,
                    type: "error",
                    duration: 2000,
                  });
                }
              });
            } else {
              ElNotification({
                title: "Tips",
                message: "new password, at least 5 characters.",
                type: "error",
                duration: 2000,
              });
            }
          } else {
            ElNotification({
              title: "Tips",
              message: "Please Enter new password",
              type: "error",
              duration: 2000,
            });
          }
        } else {
          ElNotification({
            title: "Tips",
            message: "login password, at least 5 characters.",
            type: "error",
            duration: 2000,
          });
        }
      } else {
        ElNotification({
          title: "Tips",
          message: "Please Enter login password",
          type: "error",
          duration: 2000,
        });
      }
    };
    // 发送邮箱验证码
    const sendBindEmailCode = () => {
      let emailStr = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      // 是否可以再次点击
      if (isSendBindEmailCodeAgain.value) {
        // 已输入邮箱地址
        if (state.bindEmailFormData.email) {
          // 邮箱地址正确
          if (emailStr.test(state.bindEmailFormData.email)) {
            let data = {
              token: localStorage.getItem("token"),
              email: state.bindEmailFormData.email,
            };
            sendBindEmailVerifyCodeApi(data).then((res) => {
              console.log("sendBindEmailVerifyCodeApi", res);
              if (res.data.success) {
                ElNotification({
                  title: "Tips",
                  message: "Verification code has been sent",
                  type: "success",
                });
                isSendBindEmailCodeAgain.value = false;
                bindEmailCodeInterval = setInterval(() => {
                  if (bindEmailCodeTime.value > 0) {
                    bindEmailCodeText.value = bindEmailCodeTime.value + "s";
                    bindEmailCodeTime.value--;
                  } else {
                    isSendBindEmailCodeAgain.value = true;
                    bindEmailCodeTime.value = 60;
                    bindEmailCodeText.value = "Send";
                    clearInterval(bindEmailCodeInterval);
                  }
                }, 1000);
              } else {
                ElNotification({
                  title: "Tips",
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          } else {
            ElNotification({
              title: "Tips",
              message:
                "The format of the email address you entered is incorrect.",
              type: "error",
            });
          }
        } else {
          ElNotification({
            title: "Tips",
            message: "Please Enter your email address.",
            type: "error",
          });
        }
      }
    };
    // 绑定邮箱
    const bindEmail = () => {
      if (state.bindEmailFormData.email) {
        let emailStr = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
        // 邮箱地址正确
        if (emailStr.test(state.bindEmailFormData.email)) {
          if (state.bindEmailFormData.code) {
            let data = {
              token: localStorage.getItem("token"),
              email: state.bindEmailFormData.email,
              verify_code: state.bindEmailFormData.code,
            };
            userBindEmailApi(data).then((res) => {
              if (res.data.success) {
                ElNotification({
                  title: "Tips",
                  message: "Bind Email Success",
                  type: "success",
                  duration: 2000,
                });
                bindEmailRef.value.close();
                getUserInfo();
                nextTick(() => {
                  state.bindEmailFormData.email = "";
                  state.bindEmailFormData.code = "";
                });
              } else {
                ElNotification({
                  title: "Tips",
                  message: res.data.msg,
                  type: "error",
                  duration: 2000,
                });
              }
            });
          } else {
            ElNotification({
              title: "Tips",
              message: "Please enter email Verification code",
              type: "error",
            });
          }
        } else {
          ElNotification({
            title: "Tips",
            message:
              "The format of the email address you entered is incorrect.",
            type: "error",
          });
        }
      } else {
        ElNotification({
          title: "Tips",
          message: "Please Enter your email address.",
          type: "error",
        });
      }
    };
    // 发送手机验证码
    const sendBindPhoneCode = () => {
      if (isSendBindPhoneCodeAgain.value) {
        if (state.bindPhoneFormData.phone) {
          let telStr = /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/;
          if (telStr.test(state.bindPhoneFormData.phone)) {
            let data = {
              whatsapp:
                bindPhoneCountryCode.value + state.bindPhoneFormData.phone,
            };
            getWhatsAppVerificationCodeApi(data).then((res) => {
              console.log("getWhatsAppVerificationCodeApi", res);
              if (res.data.success) {
                ElNotification({
                  title: "Tips",
                  message: "Verification code has been sent",
                  type: "success",
                });
                isSendBindPhoneCodeAgain.value = false;
                bindPhoneCodeInterval = setInterval(() => {
                  if (bindPhoneCodeTime.value > 0) {
                    bindPhoneCodeText.value = bindPhoneCodeTime.value + "s";
                    bindPhoneCodeTime.value--;
                  } else {
                    isSendBindPhoneCodeAgain.value = true;
                    bindPhoneCodeTime.value = 60;
                    bindPhoneCodeText.value = "Send";
                    clearInterval(bindPhoneCodeInterval);
                  }
                }, 1000);
              } else {
                ElNotification({
                  title: "Tips",
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          } else {
            ElNotification({
              title: "Tips",
              message:
                "The format of the phone number you entered is incorrect.",
              type: "error",
            });
          }
        } else {
          ElNotification({
            title: "Tips",
            message: "Please Enter your phone number.",
            type: "error",
          });
        }
      }
    };
    const bindPhone = () => {
      if (state.bindPhoneFormData.phone) {
        let telStr = /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/;
        if (telStr.test(state.bindPhoneFormData.phone)) {
          if (state.bindPhoneFormData.code) {
            let data = {
              token: localStorage.getItem("token"),
              whatsapp:
                bindPhoneCountryCode.value + state.bindPhoneFormData.phone,
              code: state.bindPhoneFormData.code,
            };
            userBindPhoneApi(data).then((res) => {
              console.log("userBindPhoneApi", res);
              if (res.data.success) {
                ElNotification({
                  title: "Tips",
                  message: "Bind Phone Success",
                  type: "success",
                  duration: 2000,
                });
                bindPhoneRef.value.close();
                getUserInfo();
                nextTick(() => {
                  state.bindPhoneFormData.phone = "";
                  state.bindPhoneFormData.code = "";
                });
              } else {
                ElNotification({
                  title: "Tips",
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          } else {
            ElNotification({
              title: "Tips",
              message: "Please Enter the code you received",
              type: "error",
            });
          }
        } else {
          ElNotification({
            title: "Tips",
            message: "The format of the phone number you entered is incorrect.",
            type: "error",
          });
        }
      } else {
        ElNotification({
          title: "Tips",
          message: "Please Enter your phone number.",
          type: "error",
        });
      }
    };
    // 修改交易密码
    const setWithdrawPassword = () => {
      if (state.withdrawPasswordFormData.withdrawPassword) {
        if (state.withdrawPasswordFormData.withdrawPassword.length >= 6) {
          if (state.withdrawPasswordFormData.withdrawPasswordAgain) {
            if (
              state.withdrawPasswordFormData.withdrawPasswordAgain ===
              state.withdrawPasswordFormData.withdrawPassword
            ) {
              setWithdrawPasswordApi({
                token: localStorage.getItem("token"),
                password: state.withdrawPasswordFormData.withdrawPassword,
              }).then((res) => {
                if (res.data.success) {
                  ElNotification({
                    title: "Tips",
                    message: "Setting Success",
                    type: "success",
                    duration: 2000,
                  });
                  withdrawPasswordRef.value.close();
                  nextTick(() => {
                    state.withdrawPasswordFormData.withdrawPassword = "";
                    state.withdrawPasswordFormData.withdrawPasswordAgain = "";
                  });
                }
              });
            } else {
              ElNotification({
                title: "Tips",
                message: "Inconsistent passwords",
                type: "error",
                duration: 2000,
              });
            }
          } else {
            ElNotification({
              title: "Tips",
              message: "Please Enter withdrawal password Again",
              type: "error",
              duration: 2000,
            });
          }
        } else {
          ElNotification({
            title: "Tips",
            message: "Set your withdrawal password, at least 6 characters.",
            type: "error",
            duration: 2000,
          });
        }
      } else {
        ElNotification({
          title: "Tips",
          message: "Please Enter withdrawal password",
          type: "error",
          duration: 2000,
        });
      }
    };
    // 获取国家区号
    const getCountryCode = () => {
      getCountryCodeApi().then((res) => {
        console.log("getCountryCodeApi：", res);
        if (res.data.success) {
          if (res.data.data.length > 0) {
            state.countryCodeListData = res.data.data;
          } else {
            state.countryCodeListData = [];
            bindPhoneCountryCode.value = "233";
          }
        }
      });
    };
    const userInfoLoading = ref(false);
    // 获取用户信息
    const getUserInfo = () => {
      userInfoLoading.value = true;
      // 没有就重新请求
      getUserInfoApi({ token: localStorage.getItem("token") }).then((res) => {
        console.log("getUserInfoApi：", res);
        if (res.data.success) {
          if (res.data.data) {
            localStorage.setItem("userInfo", JSON.stringify(res.data.data));
            state.userInfoData = res.data.data;
          }
          userInfoLoading.value = false;
        }else {
          userInfoLoading.value = false;
          ElNotification({
            title: "Tips",
            message: res.data.msg,
            type: "error",
          });
        }
      });
    };
    return {
      loginPasswordRef,

      bindEmailRef,
      bindEmailCodeText,

      bindPhoneRef,
      bindPhoneCodeText,
      bindPhoneCountryCode,

      withdrawPasswordRef,

      submitSetting,
      sendBindEmailCode,
      sendBindPhoneCode,

      userInfoLoading,
      ...toRefs(state),
    };
  },
});
</script>

<style lang="less" scoped>
.set-security-container {
  padding: 20px;
  .set-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #f5f5f5;
    .set-item-left {
      font-size: 16px;
      font-weight: bold;
      text-align: left;
      .security-value {
        color: #999999;
        font-weight: 500;
        font-size: 14px;
      }
    }
  }
  .btn-edit {
    background-color: #03004d;
    border-radius: 12px;
    color: #ffffff;
  }
  .login-password-content {
    padding: 20px;
    .login-password-tips {
      margin-top: 20px;
      text-align: left;
    }
    .el-button {
      margin-top: 40px;
      background-color: #03004d;
      border-radius: 12px;
      color: #ffffff;
    }
  }
  .bind-email-content {
    padding: 20px;
    .bind-email-email {
      font-size: 22px;
    }
    .bindemail-code-text {
      width: 40px;
      color: #2d43bf;
      cursor: pointer;
    }
    .el-button {
      margin-top: 40px;
      background-color: #03004d;
      border-radius: 12px;
      color: #ffffff;
    }
  }
  .bind-phone-content {
    padding: 20px;

    .bind-phone-phone {
      font-size: 22px;
    }
    .bindphone-code-text {
      width: 40px;
      color: #2d43bf;
      cursor: pointer;
    }
    .el-button {
      margin-top: 40px;
      background-color: #03004d;
      border-radius: 12px;
      color: #ffffff;
    }
  }
  .withdraw-password-content {
    padding: 20px;
    .withdraw-password-tips {
      margin-top: 20px;
      text-align: left;
    }
    .el-button {
      margin-top: 40px;
      background-color: #03004d;
      border-radius: 12px;
      color: #ffffff;
    }
  }
  :deep(.el-form-item) {
    margin-bottom: 10px;
  }
  :deep(.el-form-item__label) {
    padding: 0;
    color: #000000;
  }
}
</style>
